import * as React from "react";
import { forwardRef } from "react";
const SvgConversation = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, fill: "none", viewBox: "0 0 14 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#CC9600", fillRule: "evenodd", d: "M1.2 1.511v7.846h2.058c.495 0 .896.401.896.896v1.517l2.15-2.15a.9.9 0 0 1 .634-.263H12.8V1.511zM0 1.206C0 .712.4.311.895.311h12.21c.494 0 .895.401.895.895v8.456c0 .494-.4.895-.895.895H7.064l-2.918 2.918a.698.698 0 0 1-1.192-.494v-2.424H.895A.895.895 0 0 1 0 9.662z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgConversation);
export { ForwardRef as ReactComponent };
